import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './features/home/home.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { 
    path: 'caracteristicas', 
    loadComponent: () => import('./features/features/features.component').then(m => m.FeaturesComponent) 
  },
  { 
    path: 'precios', 
    loadComponent: () => import('./features/home/pricing/pricing.component').then(m => m.PricingComponent) 
  },
  { 
    path: 'demo', 
    loadComponent: () => import('./features/demo/demo.component').then(m => m.DemoComponent) 
  },
  { 
    path: 'blog', 
    loadComponent: () => import('./features/blog/blog.component').then(m => m.BlogComponent) 
  },
  { 
    path: 'contacto', 
    loadComponent: () => import('./features/contact/contact.component').then(m => m.ContactComponent) 
  },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
